<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :data-cy="`${entityName}__textFieldUnique--${attributeName}Container`"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!required"
    :showHeader="showHeader"
  >
    <v-text-field
      :counter="counter"
      :data-cy="`${entityName}__textFieldUnique--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="validatorList"
      :solo="styleMap.solo"
      clearable
      required
      v-model="value"
    ></v-text-field>
  </component-wrapper>
</template>

<script>
import { validateUniqueFactory } from "@/lib/validate";

import ComponentWrapper from "./ComponentWrapper";
import userInputMixin from "./userInputMixin";

export default {
  components: {
    ComponentWrapper,
  },
  computed: {
    list() {
      return this.$store.state[this.entityName].list;
    },
  },
  created() {
    this.configureValidatorListDecorator();
  },
  methods: {
    configureValidatorListDecorator() {
      const {
        attributeName,
        entity,
        list: entityList,
        entityName,
        idAttributeName,
      } = this;

      const id = entity[idAttributeName];

      this.validatorList.push(
        validateUniqueFactory({
          attributeName,
          entityList,
          entityName,
          id,
          idAttributeName,
        })
      );
      this.configureValidatorList();
    },
  },
  mixins: [userInputMixin],
  props: {
    ruleList: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
